import {useSelector} from "react-redux";
import {selectEntity} from "state/selectors/data";

export function usePost(id) {
    return useSelector(store=>selectEntity(store, 'db.posts', id));
}